// import React, { useEffect, useState, useMemo } from 'react';
// import {
//   Container,
//   Typography,
//   Button,
//   CircularProgress,
//   Alert,
//   TextField,
//   Box,
//   Stack,
//   Chip,
//   Grid,
//   Card,
//   CardContent,
//   CardActions,
//   Collapse,
//   IconButton,
//   Divider,
//   Tooltip,
//   TablePagination
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { styled } from '@mui/material/styles';
// import axios from 'axios';
// import { useAuth } from '../../AuthContext';
// import Header1 from '../Header/Header1';
// import Footer2 from '../Footer/Footer2';
// import SearchIcon from '@mui/icons-material/Search';
// import { InputAdornment } from '@mui/material';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions
// } from '@mui/material';
// import SpeedIcon from "@mui/icons-material/Speed";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import PendingActionsIcon from "@mui/icons-material/PendingActions";
// import BlockIcon from "@mui/icons-material/Block";
// import RemoveDuplicatesButton from './RemoveDuplicatesButton';

// const API_URL = process.env.REACT_APP_API_URL;

// // Styled ExpandMore button
// const ExpandMore = styled((props) => {
//   const { expand, ...other } = props;
//   return <IconButton {...other} />;
// })(({ theme, expand }) => ({
//   transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
//   marginLeft: 'auto',
//   transition: theme.transitions.create('transform', {
//     duration: theme.transitions.duration.shortest,
//   }),
// }));

// const AdminExpertRequests = () => {
//   const { userId } = useAuth();
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [actionMsg, setActionMsg] = useState('');
//   const [userMap, setUserMap] = useState({});
//   const [searchQuery, setSearchQuery] = useState('');

//   // Pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [confirmDialog, setConfirmDialog] = useState({
//     open: false,
//     action: null,
//     userId: null,
//     message: ""
//   });

//   const [expandedIds, setExpandedIds] = useState({}); // Track which cards are expanded
//   const [loadingSeconds, setLoadingSeconds] = useState(0);

//   const [filterType, setFilterType] = useState('total'); // Added filter state

//   useEffect(() => {
//     let timer;

//     if (loading) {
//       setLoadingSeconds(0); // reset timer
//       timer = setInterval(() => {
//         setLoadingSeconds(prev => prev + 1);
//       }, 1000);
//     } else {
//       clearInterval(timer);
//       setLoadingSeconds(0); // optional reset after done
//     }

//     return () => clearInterval(timer); // cleanup on unmount or loading = false
//   }, [loading]);

//   const openConfirmDialog = (action, userId) => {
//     let message = "";

//     if (action === "approve") message = "Are you sure you want to approve this expert?";
//     if (action === "reject") message = "Are you sure you want to reject and delete this expert request?";
//     if (action === "revoke") message = "Are you sure you want to revoke this expert access?";

//     setConfirmDialog({
//       open: true,
//       action,
//       userId,
//       message
//     });
//   };

//   const handleConfirmAction = async () => {
//     const { action, userId } = confirmDialog;

//     if (action === "approve") await approveExpert(userId);
//     if (action === "reject") await rejectExpert(userId);
//     if (action === "revoke") await revokeExpert(userId);

//     setConfirmDialog({ open: false, action: null, userId: null, message: "" });
//   };

//   const fetchUser = async (id) => {
//     try {
//       const res = await axios.post(`${API_URL}/api/user/`, { userId: id });
//       return res.data;
//     } catch (err) {
//       console.error('Error fetching user info for id', id, err);
//       return null;
//     }
//   };

//   const fetchRequests = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_URL}/api/experts/`);
//       const data = res.data;
//       setRequests(data);

//       const uniqueIds = new Set();
//       data.forEach(r => {
//         if (r.user_id) uniqueIds.add(r.user_id);
//         if (r.reviewed_by) uniqueIds.add(r.reviewed_by);
//       });

//       const map = {};
//       await Promise.all([...uniqueIds].map(async (id) => {
//         const u = await fetchUser(id);
//         if (u) map[id] = u;
//       }));
//       setUserMap(map);
//     } catch (err) {
//       console.error('Error fetching expert requests:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const approveExpert = async (targetUserId) => {
//     try {
//       const payload = { user_id: targetUserId, reviewed_by: userId };
//       const res = await axios.patch(`${API_URL}/api/experts/approve/`, payload);
//       setActionMsg(res.data.message || 'Expert approved.');
//       await fetchRequests();
//     } catch (err) {
//       console.error('Error approving expert:', err);
//       setActionMsg('Error approving expert.');
//     }
//   };

//   const revokeExpert = async (targetUserId) => {
//     try {
//       const payload = { user_id: targetUserId };
//       const res = await axios.patch(`${API_URL}/api/experts/revoke/`, payload);
//       setActionMsg(res.data.message || 'Expert access revoked.');
//       await fetchRequests();
//     } catch (err) {
//       console.error('Error revoking expert:', err);
//       setActionMsg('Error removing expert access.');
//     }
//   };

//   const rejectExpert = async (targetUserId) => {
//     try {
//       const payload = { user_id: targetUserId };
//       const res = await axios.delete(`${API_URL}/api/experts/reject/`, { data: payload });
//       setActionMsg(res.data.message || 'Expert request rejected.');
//       await fetchRequests();
//     } catch (err) {
//       console.error('Error rejecting expert:', err);
//       setActionMsg('Error rejecting expert.');
//     }
//   };

//   useEffect(() => { fetchRequests(); }, []);

//   const getFullName = (id) => {
//     const u = userMap[id];
//     return u ? `${u.name || ''} ${u.surname || ''}`.trim() : 'Loading...';
//   };

//   const filtered = useMemo(() => {
//     const sq = searchQuery.toLowerCase().trim();

//     let data = [...requests];

//     // Apply filterType
//     if (filterType === 'approved') data = data.filter(r => r.status === 'approved');
//     if (filterType === 'pending') data = data.filter(r => !r.reviewed_by);
//     if (filterType === 'revoked') data = data.filter(r => r.reviewed_by && r.status !== 'approved');

//     if (!sq) return data;

//     return data.filter(r => {
//       const applicantName = getFullName(r.user_id).toLowerCase();
//       const reviewerName = r.reviewed_by ? getFullName(r.reviewed_by).toLowerCase() : '';
//       const email = (r.email || '').toLowerCase();
//       const status = (r.status || '').toLowerCase();
//       const designation = (r.designation || '').toLowerCase();
//       const expertise = (r.areas_of_expertise || '').toLowerCase();
//       const about = (r.about || '').toLowerCase();

//       return (
//         applicantName.includes(sq) ||
//         reviewerName.includes(sq) ||
//         email.includes(sq) ||
//         status.includes(sq) ||
//         designation.includes(sq) ||
//         expertise.includes(sq) ||
//         about.includes(sq)
//       );
//     });
//   }, [searchQuery, requests, userMap, filterType]);

//   const counts = useMemo(() => {
//     const total = requests.length;
//     let approved = 0, notReviewed = 0, revoked = 0;

//     requests.forEach(r => {
//       if (r.status === 'approved') approved++;
//       if (!r.reviewed_by) notReviewed++;
//       if (r.reviewed_by && r.status !== 'approved') revoked++;
//     });

//     return { total, approved, notReviewed, revoked };
//   }, [requests]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleExpandClick = (id) => {
//     setExpandedIds(prev => ({ ...prev, [id]: !prev[id] }));
//   };

//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
//       <Header1 />

//       <Container maxWidth="lg" sx={{ mt: 6, mb: 6, flexGrow: 1 }}>
//         <Typography
//           variant="h3"
//           component="h1"
//           align="center"
//           sx={{
//             backgroundImage: 'linear-gradient(45deg, #6a11cb, #2575fc)',
//             WebkitBackgroundClip: 'text',
//             color: 'transparent',
//             letterSpacing: 6,
//             fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
//             mb: 3
//           }}
//         >
//           Experts Management
//         </Typography>

//         <Stack
//           direction={{ xs: "column", sm: "row" }}
//           spacing={3}
//           justifyContent="center"
//           alignItems="center"
//           sx={{ mb: 4 }}
//         >
//           {/* Total Experts */}
//           <Box
//             onClick={() => setFilterType('total')}
//             sx={{
//               cursor: 'pointer',
//               width: 120,
//               height: 120,
//               borderRadius: "50%",
//               background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
//               border: "3px solid rgba(0, 150, 255, 0.6)",
//               boxShadow: "0 0 20px rgba(0,150,255,0.5)",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#00aaff",
//               fontWeight: 600,
//               textShadow: "0 0 8px rgba(0,150,255,0.9)",
//             }}
//           >
//             <SpeedIcon sx={{ fontSize: 26, mb: 1 }} />
//             <Typography sx={{ fontSize: 14 }}>TOTAL</Typography>
//             <Typography sx={{ fontSize: 22 }}>{counts.total}</Typography>
//           </Box>

//           {/* Approved */}
//           <Box
//             onClick={() => setFilterType('approved')}
//             sx={{
//               cursor: 'pointer',
//               width: 120,
//               height: 120,
//               borderRadius: "50%",
//               background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
//               border: "3px solid rgba(0, 255, 170, 0.6)",
//               boxShadow: "0 0 20px rgba(0,255,170,0.5)",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#00ffaa",
//               fontWeight: 600,
//               textShadow: "0 0 8px rgba(0,255,170,0.9)",
//             }}
//           >
//             <CheckCircleIcon sx={{ fontSize: 26, mb: 1 }} />
//             <Typography sx={{ fontSize: 14 }}>APPROVED</Typography>
//             <Typography sx={{ fontSize: 22 }}>{counts.approved}</Typography>
//           </Box>

//           {/* Pending */}
//           <Box
//             onClick={() => setFilterType('pending')}
//             sx={{
//               cursor: 'pointer',
//               width: 120,
//               height: 120,
//               borderRadius: "50%",
//               background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
//               border: "3px solid rgba(255, 200, 0, 0.6)",
//               boxShadow: "0 0 20px rgba(255,200,0,0.5)",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#ffcc00",
//               fontWeight: 600,
//               textShadow: "0 0 8px rgba(255,200,0,0.9)",
//             }}
//           >
//             <PendingActionsIcon sx={{ fontSize: 26, mb: 1 }} />
//             <Typography sx={{ fontSize: 14 }}>PENDING</Typography>
//             <Typography sx={{ fontSize: 22 }}>{counts.notReviewed}</Typography>
//           </Box>

//           {/* Revoked */}
//           <Box
//             onClick={() => setFilterType('revoked')}
//             sx={{
//               cursor: 'pointer',
//               width: 120,
//               height: 120,
//               borderRadius: "50%",
//               background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
//               border: "3px solid rgba(255, 70, 70, 0.6)",
//               boxShadow: "0 0 20px rgba(255,70,70,0.5)",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#ff4747",
//               fontWeight: 600,
//               textShadow: "0 0 8px rgba(255,70,70,0.9)",
//             }}
//           >
//             <BlockIcon sx={{ fontSize: 26, mb: 1 }} />
//             <Typography sx={{ fontSize: 14 }}>REVOKED</Typography>
//             <Typography sx={{ fontSize: 22 }}>{counts.revoked}</Typography>
//           </Box>
//         </Stack>
//         <RemoveDuplicatesButton/>

//         {/* ... rest of your code (search input, alerts, loading, cards, pagination, dialog) stays the same ... */}




//        <Box display="flex" justifyContent="center" mb={3}>
//   <Box flex="1 1 100%" maxWidth={{ xs: '100%', sm: '600px', md: '500px' }}>
//     <TextField
//       label="Search experts by name, email, status, designation..."
//       variant="outlined"
//       fullWidth
//       size="medium"
//       value={searchQuery}
//       onChange={(e) => setSearchQuery(e.target.value)}
//       autoComplete="off"
//       sx={{
//         borderRadius: 3,
//         backgroundColor: '#1e1e1e', // dark input background
//         color: '#fff',               // text color
//         boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
//         '& .MuiOutlinedInput-root': {
//           borderRadius: 3,
//           color: '#fff',
//           '& fieldset': {
//             borderColor: '#555',
//           },
//           '&:hover fieldset': {
//             borderColor: '#00bfff',
//           },
//           '&.Mui-focused fieldset': {
//             borderColor: '#00bfff',
//             boxShadow: '0 0 10px #00bfff33',
//           },
//         },
//         '& .MuiInputLabel-root': {
//           color: '#bbb', // lighter label
//         },
//         '& .MuiInputLabel-root.Mui-focused': {
//           color: '#00bfff',
//         },
//         '& .MuiInputBase-input': {
//           color: '#fff', // input text
//         },
//         '& .MuiSvgIcon-root': {
//           color: '#bbb', // search icon color
//         },
//       }}
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <SearchIcon />
//           </InputAdornment>
//         ),
//       }}
//     />
//   </Box>
// </Box>


//         {actionMsg && <Alert severity="info" sx={{ mb: 2 }}>{actionMsg}</Alert>}

//         {loading ? (
//           <Box
//             sx={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               width: '100vw',
//               height: '100vh',
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               zIndex: 2000,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               backdropFilter: 'blur(3px)',
//             }}
//           >
//             <Box sx={{ textAlign: 'center' }}>
//               <CircularProgress
//                 size={60}
//                 thickness={6}
//                 sx={{
//                   color: 'transparent',
//                   '& .MuiCircularProgress-circle': {
//                     stroke: 'url(#better-gradient)',
//                   },
//                 }}
//               />

//               <svg width="0" height="0">
//                 <defs>
//                   <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
//                     <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
//                     <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
//                   </linearGradient>
//                 </defs>
//               </svg>

//               <Typography
//                 variant="h6"
//                 sx={{
//                   mt: 2,
//                   color: '#fff',
//                   textShadow: '0 1px 3px rgba(0,0,0,0.7)',
//                 }}
//               >
//                 Loading Session Details... ({loadingSeconds} sec)
//               </Typography>
//             </Box>
//           </Box>
//         ) : (
//           <>
//             <Box>
//   {filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((r) => (
//     <Box key={r.id} mb={3}>
//       <Card variant="outlined">
//         <CardContent>
//           <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//             {getFullName(r.user_id)}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {r.email} | {r.contact}
//           </Typography>
//            <Typography variant="body2">
//   <strong>Consultation Fee:</strong> ₹{r.consultation_fee || "Not set"}
// </Typography>

//           <Box display="flex" flexWrap="wrap" gap={1} mt={1} mb={1}>
//             <Chip label={r.designation} size="small" color="info" />
//             <Chip
//               label={r.status}
//               size="small"
//               color={
//                 r.status === 'approved' ? 'success' :
//                 r.status === 'revoked' ? 'error' : 'warning'
//               }
//             />
//             <Chip
//               label={r.reviewed_by ? `Reviewed by ${getFullName(r.reviewed_by)}` : 'Not Reviewed'}
//               size="small"
//             />
//           </Box>

//           <Typography variant="body2" noWrap>
//             <strong>Applied at:</strong> {new Date(r.created_at).toLocaleString()}
//           </Typography>
//           <Typography variant="body2" noWrap>
//             <strong>Updated at:</strong> {new Date(r.updated_at).toLocaleString()}
//           </Typography>

//           <Divider sx={{ my: 1 }} />

//           <Typography variant="body2" noWrap>
//             <strong>Expertise:</strong> {r.areas_of_expertise}
//           </Typography>
//           <Typography variant="body2" noWrap>
//             <strong>About:</strong> {r.about}
//           </Typography>
         
//         </CardContent>

//         <CardActions disableSpacing>
//           <Tooltip title={expandedIds[r.id] ? "Collapse Details" : "Expand Details"}>
//             <ExpandMore
//               expand={expandedIds[r.id]}
//               onClick={() => handleExpandClick(r.id)}
//             >
//               <ExpandMoreIcon />
//             </ExpandMore>
//           </Tooltip>

//           {r.status === "pending" && (
//             <Box display="flex" ml="auto" gap={1}>
//               <Button
//                 variant="contained"
//                 color="success"
//                 size="small"
//                 onClick={() => openConfirmDialog("approve", r.user_id)}
//               >
//                 Approve
//               </Button>

//               <Button
//                 variant="outlined"
//                 color="error"
//                 size="small"
//                 onClick={() => openConfirmDialog("reject", r.user_id)}
//               >
//                 Reject
//               </Button>
//             </Box>
//           )}

//           {r.status === "approved" && (
//             <Button
//               variant="outlined"
//               color="error"
//               size="small"
//               sx={{ ml: "auto" }}
//               onClick={() => openConfirmDialog("revoke", r.user_id)}
//             >
//               Remove
//             </Button>
//           )}
//         </CardActions>

//         <Collapse in={expandedIds[r.id]} timeout="auto" unmountOnExit>
//           <CardContent>
//             <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
//               <strong>Full Areas of Expertise:</strong> {r.areas_of_expertise}
//             </Typography>
//             <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
//               <strong>About:</strong> {r.about}
//             </Typography>
//           </CardContent>
//         </Collapse>
//       </Card>
//     </Box>
//   ))}

//   {filtered.length === 0 && (
//     <Box mb={3}>
//       <Alert severity="info" align="center">No experts found.</Alert>
//     </Box>
//   )}
// </Box>


//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//               <TablePagination
//                 component="div"
//                 count={filtered.length}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 rowsPerPage={rowsPerPage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 rowsPerPageOptions={[5, 10, 25]}
//               />
//             </Box>
//           </>

//         )}
//         <Dialog
//   open={confirmDialog.open}
//   onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
// >
//   <DialogTitle>Confirm Action</DialogTitle>
//   <DialogContent>
//     <DialogContentText>{confirmDialog.message}</DialogContentText>
//   </DialogContent>

//   <DialogActions>
//     <Button onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}>
//       Cancel
//     </Button>
//     <Button variant="contained" color="error" onClick={handleConfirmAction}>
//       Confirm
//     </Button>
//   </DialogActions>
// </Dialog>

//       </Container>

//       <Footer2 />
//     </Box>
//   );
// };

// export default AdminExpertRequests;


import React, { useEffect, useState, useMemo } from 'react';
import {
  Container,
  Typography,
  Button,
  CircularProgress,
  Alert,
  TextField,
  Box,
  Stack,
  Chip,
  Grid,
  Card,
  CardContent,
  CardActions,
  Collapse,
  IconButton,
  Divider,
  Tooltip,
  TablePagination
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { useAuth } from '../../AuthContext';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import SpeedIcon from "@mui/icons-material/Speed";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import BlockIcon from "@mui/icons-material/Block";
import RemoveDuplicatesButton from './RemoveDuplicatesButton';
import AdminEditExpertDialog from './AdminEditExpertDialog';
import {api} from '../Login/axiosConfig';

const API_URL = process.env.REACT_APP_API_URL;

// Styled ExpandMore button
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const AdminExpertRequests = () => {
  const { userId } = useAuth();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionMsg, setActionMsg] = useState('');
  const [userMap, setUserMap] = useState({});
  const [searchQuery, setSearchQuery] = useState('');

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    action: null,
    userId: null,
    message: ""
  });

  const [expandedIds, setExpandedIds] = useState({});
  const [loadingSeconds, setLoadingSeconds] = useState(0);
  const [filterType, setFilterType] = useState('total');

  // ── Edit dialog state ──────────────────────────────────────────────────────
  const [editDialog, setEditDialog] = useState({ open: false, expert: null });

  const openEditDialog = (expert) => setEditDialog({ open: true, expert });
  const closeEditDialog = () => setEditDialog({ open: false, expert: null });
  // ──────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    let timer;
    if (loading) {
      setLoadingSeconds(0);
      timer = setInterval(() => {
        setLoadingSeconds(prev => prev + 1);
      }, 1000);
    } else {
      clearInterval(timer);
      setLoadingSeconds(0);
    }
    return () => clearInterval(timer);
  }, [loading]);

  const openConfirmDialog = (action, userId) => {
    let message = "";
    if (action === "approve") message = "Are you sure you want to approve this expert?";
    if (action === "reject") message = "Are you sure you want to reject and delete this expert request?";
    if (action === "revoke") message = "Are you sure you want to revoke this expert access?";
    setConfirmDialog({ open: true, action, userId, message });
  };

  const handleConfirmAction = async () => {
    const { action, userId } = confirmDialog;
    if (action === "approve") await approveExpert(userId);
    if (action === "reject") await rejectExpert(userId);
    if (action === "revoke") await revokeExpert(userId);
    setConfirmDialog({ open: false, action: null, userId: null, message: "" });
  };

  const fetchUser = async (id) => {
    try {
      const res = await axios.post(`${API_URL}/api/user/`, { userId: id });
      return res.data;
    } catch (err) {
      console.error('Error fetching user info for id', id, err);
      return null;
    }
  };

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/experts/`);
      const data = res.data;
      setRequests(data);

      const uniqueIds = new Set();
      data.forEach(r => {
        if (r.user_id) uniqueIds.add(r.user_id);
        if (r.reviewed_by) uniqueIds.add(r.reviewed_by);
      });

      const map = {};
      await Promise.all([...uniqueIds].map(async (id) => {
        const u = await fetchUser(id);
        if (u) map[id] = u;
      }));
      setUserMap(map);
    } catch (err) {
      console.error('Error fetching expert requests:', err);
    } finally {
      setLoading(false);
    }
  };

  const approveExpert = async (targetUserId) => {
    try {
      const payload = { user_id: targetUserId, reviewed_by: userId };
      const res = await axios.patch(`${API_URL}/api/experts/approve/`, payload);
      setActionMsg(res.data.message || 'Expert approved.');
      await fetchRequests();
    } catch (err) {
      console.error('Error approving expert:', err);
      setActionMsg('Error approving expert.');
    }
  };

  const revokeExpert = async (targetUserId) => {
    try {
      const payload = { user_id: targetUserId };
      const res = await axios.patch(`${API_URL}/api/experts/revoke/`, payload);
      setActionMsg(res.data.message || 'Expert access revoked.');
      await fetchRequests();
    } catch (err) {
      console.error('Error revoking expert:', err);
      setActionMsg('Error removing expert access.');
    }
  };

  const rejectExpert = async (targetUserId) => {
    try {
      const payload = { user_id: targetUserId };
      const res = await axios.delete(`${API_URL}/api/experts/reject/`, { data: payload });
      setActionMsg(res.data.message || 'Expert request rejected.');
      await fetchRequests();
    } catch (err) {
      console.error('Error rejecting expert:', err);
      setActionMsg('Error rejecting expert.');
    }
  };

  useEffect(() => { fetchRequests(); }, []);

  const getFullName = (id) => {
    const u = userMap[id];
    return u ? `${u.name || ''} ${u.surname || ''}`.trim() : 'Loading...';
  };

  const filtered = useMemo(() => {
    const sq = searchQuery.toLowerCase().trim();
    let data = [...requests];

    if (filterType === 'approved') data = data.filter(r => r.status === 'approved');
    if (filterType === 'pending') data = data.filter(r => !r.reviewed_by);
    if (filterType === 'revoked') data = data.filter(r => r.reviewed_by && r.status !== 'approved');

    if (!sq) return data;

    return data.filter(r => {
      const applicantName = getFullName(r.user_id).toLowerCase();
      const reviewerName = r.reviewed_by ? getFullName(r.reviewed_by).toLowerCase() : '';
      const email = (r.email || '').toLowerCase();
      const status = (r.status || '').toLowerCase();
      const designation = (r.designation || '').toLowerCase();
      const expertise = (r.areas_of_expertise || '').toLowerCase();
      const about = (r.about || '').toLowerCase();

      return (
        applicantName.includes(sq) ||
        reviewerName.includes(sq) ||
        email.includes(sq) ||
        status.includes(sq) ||
        designation.includes(sq) ||
        expertise.includes(sq) ||
        about.includes(sq)
      );
    });
  }, [searchQuery, requests, userMap, filterType]);

  const counts = useMemo(() => {
    const total = requests.length;
    let approved = 0, notReviewed = 0, revoked = 0;
    requests.forEach(r => {
      if (r.status === 'approved') approved++;
      if (!r.reviewed_by) notReviewed++;
      if (r.reviewed_by && r.status !== 'approved') revoked++;
    });
    return { total, approved, notReviewed, revoked };
  }, [requests]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExpandClick = (id) => {
    setExpandedIds(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header1 />

      <Container maxWidth="lg" sx={{ mt: 6, mb: 6, flexGrow: 1 }}>
        <Typography
          variant="h3"
          component="h1"
          align="center"
          sx={{
            backgroundImage: 'linear-gradient(45deg, #6a11cb, #2575fc)',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            letterSpacing: 6,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            mb: 3
          }}
        >
          Experts Management
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          {/* Total Experts */}
          <Box
            onClick={() => setFilterType('total')}
            sx={{
              cursor: 'pointer',
              width: 120, height: 120, borderRadius: "50%",
              background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
              border: "3px solid rgba(0, 150, 255, 0.6)",
              boxShadow: "0 0 20px rgba(0,150,255,0.5)",
              display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              color: "#00aaff", fontWeight: 600, textShadow: "0 0 8px rgba(0,150,255,0.9)",
            }}
          >
            <SpeedIcon sx={{ fontSize: 26, mb: 1 }} />
            <Typography sx={{ fontSize: 14 }}>TOTAL</Typography>
            <Typography sx={{ fontSize: 22 }}>{counts.total}</Typography>
          </Box>

          {/* Approved */}
          <Box
            onClick={() => setFilterType('approved')}
            sx={{
              cursor: 'pointer',
              width: 120, height: 120, borderRadius: "50%",
              background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
              border: "3px solid rgba(0, 255, 170, 0.6)",
              boxShadow: "0 0 20px rgba(0,255,170,0.5)",
              display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              color: "#00ffaa", fontWeight: 600, textShadow: "0 0 8px rgba(0,255,170,0.9)",
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 26, mb: 1 }} />
            <Typography sx={{ fontSize: 14 }}>APPROVED</Typography>
            <Typography sx={{ fontSize: 22 }}>{counts.approved}</Typography>
          </Box>

          {/* Pending */}
          <Box
            onClick={() => setFilterType('pending')}
            sx={{
              cursor: 'pointer',
              width: 120, height: 120, borderRadius: "50%",
              background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
              border: "3px solid rgba(255, 200, 0, 0.6)",
              boxShadow: "0 0 20px rgba(255,200,0,0.5)",
              display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              color: "#ffcc00", fontWeight: 600, textShadow: "0 0 8px rgba(255,200,0,0.9)",
            }}
          >
            <PendingActionsIcon sx={{ fontSize: 26, mb: 1 }} />
            <Typography sx={{ fontSize: 14 }}>PENDING</Typography>
            <Typography sx={{ fontSize: 22 }}>{counts.notReviewed}</Typography>
          </Box>

          {/* Revoked */}
          <Box
            onClick={() => setFilterType('revoked')}
            sx={{
              cursor: 'pointer',
              width: 120, height: 120, borderRadius: "50%",
              background: "radial-gradient(circle at 50% 40%, #0d0d0d, #000)",
              border: "3px solid rgba(255, 70, 70, 0.6)",
              boxShadow: "0 0 20px rgba(255,70,70,0.5)",
              display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              color: "#ff4747", fontWeight: 600, textShadow: "0 0 8px rgba(255,70,70,0.9)",
            }}
          >
            <BlockIcon sx={{ fontSize: 26, mb: 1 }} />
            <Typography sx={{ fontSize: 14 }}>REVOKED</Typography>
            <Typography sx={{ fontSize: 22 }}>{counts.revoked}</Typography>
          </Box>
        </Stack>

        <RemoveDuplicatesButton />
        <Button
  variant="contained"
  onClick={async () => {
    try {
      // ✅ Changed from /admin/ to /api/admin-tools/
      const res = await api.post(`/api/generate-appointment-types/`);
      alert(res.data.message);
    } catch (err) {
      // ✅ Surface the actual error — not just a generic message
      const detail = err.response?.data?.detail || err.response?.status || err.message;
      alert(`Failed: ${detail}`);
    }
  }}
  sx={{
    mt: 2,
    px: 3,
    py: 1.2,
    borderRadius: "12px",
    fontWeight: 500,
    textTransform: "none",
    fontSize: "0.85rem",

    background: "linear-gradient(90deg, #1E90FF, #4f9eff)",
    boxShadow: "0 4px 18px rgba(79,158,255,0.3)",

    transition: "all 0.25s ease",

    "&:hover": {
      background: "linear-gradient(90deg, #3aa0ff, #66b2ff)",
      boxShadow: "0 6px 24px rgba(79,158,255,0.45)",
      transform: "translateY(-1px)",
    },

    "&:active": {
      transform: "scale(0.97)",
    },
  }}
>
  Generate Appointment Types
</Button>

        {/* Search */}
        <Box display="flex" justifyContent="center" mb={3}>
          <Box flex="1 1 100%" maxWidth={{ xs: '100%', sm: '600px', md: '500px' }}>
            <TextField
              label="Search experts by name, email, status, designation..."
              variant="outlined"
              fullWidth
              size="medium"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoComplete="off"
              sx={{
                borderRadius: 3,
                backgroundColor: '#1e1e1e',
                color: '#fff',
                boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
                '& .MuiOutlinedInput-root': {
                  borderRadius: 3, color: '#fff',
                  '& fieldset': { borderColor: '#555' },
                  '&:hover fieldset': { borderColor: '#00bfff' },
                  '&.Mui-focused fieldset': { borderColor: '#00bfff', boxShadow: '0 0 10px #00bfff33' },
                },
                '& .MuiInputLabel-root': { color: '#bbb' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#00bfff' },
                '& .MuiInputBase-input': { color: '#fff' },
                '& .MuiSvgIcon-root': { color: '#bbb' },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        {actionMsg && <Alert severity="info" sx={{ mb: 2 }}>{actionMsg}</Alert>}

        {loading ? (
          <Box
            sx={{
              position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 2000,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              backdropFilter: 'blur(3px)',
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <CircularProgress
                size={60} thickness={6}
                sx={{ color: 'transparent', '& .MuiCircularProgress-circle': { stroke: 'url(#better-gradient)' } }}
              />
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#f30b96ff" />
                    <stop offset="50%" stopColor="#221ce0ff" />
                    <stop offset="100%" stopColor="#0eacebff" />
                  </linearGradient>
                </defs>
              </svg>
              <Typography variant="h6" sx={{ mt: 2, color: '#fff', textShadow: '0 1px 3px rgba(0,0,0,0.7)' }}>
                Loading Session Details... ({loadingSeconds} sec)
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
            <Box>
              {filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((r) => (
                <Box key={r.id} mb={3}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {getFullName(r.user_id)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {r.email} | {r.contact}
                      </Typography>

                      {/* ── Consultation Fee ── */}
                      <Typography variant="body2">
                        <strong>Consultation Fee:</strong> ₹{r.consultation_fee || "Not set"}
                      </Typography>

                      <Box display="flex" flexWrap="wrap" gap={1} mt={1} mb={1}>
                        {r.linkedin_verified && (
  <Chip
    label="LinkedIn Verified"
    color="primary"
    sx={{
      fontWeight: 700,
      background:
        "linear-gradient(45deg,#0077B5,#0A66C2)",
      color: "white",
    }}
  />
)}
                        <Chip label={r.designation} size="small" color="info" />
                        <Chip
                          label={r.status}
                          size="small"
                          color={
                            r.status === 'approved' ? 'success' :
                            r.status === 'revoked' ? 'error' : 'warning'
                          }
                        />
                        <Chip
                          label={r.reviewed_by ? `Reviewed by ${getFullName(r.reviewed_by)}` : 'Not Reviewed'}
                          size="small"
                        />
                      </Box>

                      <Typography variant="body2" noWrap>
                        <strong>Applied at:</strong> {new Date(r.created_at).toLocaleString()}
                      </Typography>
                      <Typography variant="body2" noWrap>
                        <strong>Updated at:</strong> {new Date(r.updated_at).toLocaleString()}
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Typography variant="body2" noWrap>
                        <strong>Expertise:</strong> {r.areas_of_expertise}
                      </Typography>
                      <Typography variant="body2" noWrap>
                        <strong>About:</strong> {r.about}
                      </Typography>
                    </CardContent>

                    <CardActions disableSpacing>
                      <Tooltip title={expandedIds[r.id] ? "Collapse Details" : "Expand Details"}>
                        <ExpandMore expand={expandedIds[r.id]} onClick={() => handleExpandClick(r.id)}>
                          <ExpandMoreIcon />
                        </ExpandMore>
                      </Tooltip>

                      {/* ── Action buttons ── */}
                      <Box display="flex" ml="auto" gap={1} flexWrap="wrap" justifyContent="flex-end">

                        {/* Edit button — visible for pending or approved */}
                        {(r.status === 'pending' || r.status === 'approved') && (
                          <Tooltip title="Edit expert details">
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<EditIcon />}
                              onClick={() => openEditDialog(r)}
                              sx={{
                                borderColor: '#00bfff',
                                color: '#00bfff',
                                '&:hover': { borderColor: '#009fd4', color: '#009fd4', backgroundColor: 'rgba(0,191,255,0.05)' }
                              }}
                            >
                              Edit
                            </Button>
                          </Tooltip>
                        )}

                        {r.status === "pending" && (
                          <>
                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              onClick={() => openConfirmDialog("approve", r.user_id)}
                            >
                              Approve
                            </Button>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              onClick={() => openConfirmDialog("reject", r.user_id)}
                            >
                              Reject
                            </Button>
                          </>
                        )}

                        {r.status === "approved" && (
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => openConfirmDialog("revoke", r.user_id)}
                          >
                            Remove
                          </Button>
                        )}
                      </Box>
                    </CardActions>

                    <Collapse in={expandedIds[r.id]} timeout="auto" unmountOnExit>
                      <CardContent>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                          <strong>Full Areas of Expertise:</strong> {r.areas_of_expertise}
                        </Typography>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
                          <strong>About:</strong> {r.about}
                        </Typography>
                      </CardContent>
                    </Collapse>
                  </Card>
                </Box>
              ))}

              {filtered.length === 0 && (
                <Box mb={3}>
                  <Alert severity="info" align="center">No experts found.</Alert>
                </Box>
              )}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <TablePagination
                component="div"
                count={filtered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
              />
            </Box>
          </>
        )}

        {/* Confirm Action Dialog (unchanged) */}
        <Dialog
          open={confirmDialog.open}
          onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        >
          <DialogTitle>Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText>{confirmDialog.message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}>
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirmAction}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Edit Expert Dialog ── */}
        <AdminEditExpertDialog
          open={editDialog.open}
          onClose={closeEditDialog}
          expert={editDialog.expert}
          expertName={editDialog.expert ? getFullName(editDialog.expert.user_id) : ''}
          onSaved={() => {
            setActionMsg('Expert profile updated successfully.');
            fetchRequests();
          }}
        />
      </Container>

      <Footer2 />
    </Box>
  );
};

export default AdminExpertRequests;